/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFreeHand = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m16.429 2.586 3.985 3.985L8.246 18.74a9.948 9.948 0 0 1 .629.48c.638.51 1.013.78 1.625.78.612 0 .988-.27 1.625-.78l.047-.038C12.782 18.693 13.647 18 15 18s2.218.693 2.828 1.182l.047.037c.638.51 1.013.781 1.625.781H22v2h-2.5c-1.353 0-2.218-.693-2.828-1.182l-.047-.037C15.988 20.27 15.612 20 15 20s-.987.27-1.625.78l-.047.038C12.718 21.307 11.853 22 10.5 22c-1.353 0-2.218-.693-2.828-1.182a11.845 11.845 0 0 0-.047-.037C6.987 20.27 6.612 20 6 20H3v-3.986zM6.157 18l8.429-8.429-1.157-1.157L5 16.843V18zm8.686-11L16 8.157l1.586-1.586-1.157-1.157z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgFreeHand as FreeHand };
